import React from 'react'
import { FileEmulationDataReport } from './emulation-data'
import { AllFilesTypes } from '../../types'
import { MultiFilesFilteredLayout } from '../../components/filter/multi-files-filtered'
import { useURLSearchParam } from 'app/modules/shared'

type FilesEmulationDataReportProps = {
  data: { [fileKey: string]: any }
  filesType: AllFilesTypes
}
export function FilesEmulationDataReport(props: FilesEmulationDataReportProps): JSX.Element {
  const { data, filesType } = props
  const collapseId = useURLSearchParam('collapseId')

  return (
    <MultiFilesFilteredLayout
      data={data}
      filesType={filesType}
      applyFilter={(data) => data} // Do not perform filtering on multi-files layout page, but do this inside file component
      fileContentComponent={FileEmulationDataReport as React.FunctionComponent}
      selected={collapseId}
    />
  )
}
